import { render, staticRenderFns } from "./tagInput.vue?vue&type=template&id=aa7be500&"
import script from "./tagInput.vue?vue&type=script&lang=js&"
export * from "./tagInput.vue?vue&type=script&lang=js&"
import style0 from "./tagInput.vue?vue&type=style&index=0&id=aa7be500&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports